import { CleaveOptions } from 'cleave.js/options';
import { Field } from 'formik';
import { FieldProps } from 'formik/dist/Field';
import React from 'react';
import { AutoCompleteTypes, MaskedTextField } from '../MaskedTextField';
import { getErrorText } from './getErrorText';

type TextFieldProps = {
    name: string;
    testId: string;
    label?: string;
    required?: boolean;
    disabled?: boolean;
    readOnly?: boolean;
    helperText?: string;
    autoFocus?: boolean;
    multiline?: boolean;
    disabledTruncation?: boolean;
    placeholder?: string;
    rowsMax?: number;
    maxLength?: number;
    hideCharacterLimit?: boolean;
    warningText?: string;
    startAdornment?: React.ReactNode;
    autoCompleteType?: AutoCompleteTypes;
    formatOptions?: CleaveOptions;
    shrinkLabel?: boolean;
    hideWarningEmptyHelperText?: boolean;
    forceErrorCheck?(value: string): boolean;
    filterFunction?(value: string): string;
    formatFunction?(value: string): string;
    unformatFunction?(value: string): string;
    onClear?(): void;
    onChange?(value: string, event?: React.ChangeEvent<HTMLInputElement>): void;
    onKeyDown?(e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>): void;
};

export function FormikTextField(props: TextFieldProps) {
    return (
        <Field name={props.name}>
            {({ field, form }: FieldProps) => {
                const { forceErrorCheck, ...otherProps } = props;
                const errorText = getErrorText(
                    form,
                    field.name,
                    forceErrorCheck ? forceErrorCheck(field.value) : false
                );
                const onClear = () => {
                    form.setFieldTouched(field.name);
                    form.setFieldValue(field.name, '');

                    if (props.onClear) props.onClear();
                };

                const onChange = (value: string, event?: React.ChangeEvent<HTMLInputElement>) => {
                    form.setFieldTouched(field.name);
                    form.setFieldValue(field.name, value);

                    if (props.onChange) props.onChange(value, event);
                };

                return (
                    <MaskedTextField
                        {...otherProps}
                        value={field.value || ''}
                        name={field.name}
                        fullWidth
                        onChange={onChange}
                        onKeyDown={props.onKeyDown}
                        onClear={onClear}
                        errorText={errorText}
                        shrinkLabel={props.shrinkLabel && !!field.value}
                    />
                );
            }}
        </Field>
    );
}
